import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
} from '@/components/atoms/Sidebar';

import { useLocation } from 'react-router-dom';
import { AppSidebarHeader } from './AppSidebarHeader';
import { HasSubMenuItem } from './HasSubMenuItem';
import { DefaultItem } from './DefaultItem';
import { SIDEBAR_ITEMS } from './config';
import { useSidebar } from '@/components/atoms/Sidebar';
import { ROUTES } from '@/routes';

export function AppSidebar() {
  const location = useLocation();
  const { state, isMobile } = useSidebar();

  // 주요 파라미터만 비교하는 헬퍼
  const isParamsMatch = (subUrl: string, keysToCheck: string[]) => {
    const [subPath, subQuery] = subUrl.split('?');
    if (location.pathname !== subPath) return false;
    if (!subQuery) return true;
    const subParams = new URLSearchParams(subQuery);
    const locParams = new URLSearchParams(location.search);
    return keysToCheck.every((key) =>
      subParams.has(key) ? locParams.get(key) === subParams.get(key) : true,
    );
  };

  return (
    <Sidebar
      className="z-20 flex flex-col border-r border-gr-300 bg-white py-[24px]"
      collapsible="icon"
    >
      <AppSidebarHeader />
      <SidebarContent className="mt-[26px] items-center ">
        <SidebarGroup className={` max-w-[240px] py-0 ${state === 'expanded' && 'px-[20px]'}`}>
          <SidebarGroupContent>
            <SidebarMenu className="gap-2">
              {SIDEBAR_ITEMS.map((item) => {
                let isActive = false;

                // "더보기" 메뉴 분기
                if (item.url === ROUTES.more && item.subItems) {
                  if (location.pathname === ROUTES.more) {
                    const params = new URLSearchParams(location.search);
                    const ctab = params.get('ctab');
                    if (!ctab) {
                      isActive = false;
                    } else {
                      isActive = item.subItems.some((sub) => {
                        if (typeof sub.url !== 'string' || !sub.url.startsWith(ROUTES.more))
                          return false;
                        const subParams = new URLSearchParams(sub.url.split('?')[1] || '');
                        return subParams.get('ctab') === ctab;
                      });
                    }
                  }
                  // 외부 링크는 따로 처리
                  isActive =
                    isActive ||
                    item.subItems.some(
                      (sub) =>
                        typeof sub.url === 'string' &&
                        sub.url.startsWith('http') &&
                        location.pathname + location.search === sub.url,
                    );
                } else if (item.url === ROUTES.orders && item.subItems) {
                  // 주문 내역
                  const isOrderDetailActive =
                    location.pathname === ROUTES.orderDetails &&
                    new URLSearchParams(location.search).has('orderTab');
                  // 리뷰 관리
                  const isReviewActive = location.pathname === ROUTES.reviews;
                  // 문의 관리
                  const isInquiryActive = location.pathname === ROUTES.inquiries;

                  isActive = isOrderDetailActive || isReviewActive || isInquiryActive;

                  // 외부 링크(예: 공지사항 등)는 기존대로...
                  isActive =
                    isActive ||
                    item.subItems.some(
                      (sub) =>
                        typeof sub.url === 'string' &&
                        sub.url.startsWith('http') &&
                        location.pathname + location.search === sub.url,
                    );
                }

                // "마켓" 메뉴 분기 (market/register/~~ 포함)
                else if (item.url === ROUTES.market) {
                  isActive =
                    location.pathname === ROUTES.market ||
                    location.pathname.startsWith(ROUTES.marketRegister);
                }
                // 그 외 메뉴
                else {
                  isActive =
                    location.pathname === item.url ||
                    (item.subItems &&
                      item.subItems.some(
                        (sub) =>
                          typeof sub.url === 'string' &&
                          location.pathname + location.search === sub.url,
                      ));
                }

                const hasSubMenu = !!item.subItems;
                return hasSubMenu ? (
                  <HasSubMenuItem item={item} isActive={isActive} key={item.title} />
                ) : (
                  <DefaultItem item={item} isActive={isActive} key={item.title} />
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
